import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';

export interface PatchCollectionPointsPayloadResponse {
  status?: string;
  collection?: string;
  external_id?: string;
  points_updated?: number;
  detail?: string;
}

interface PatchCollectionPointsPayloadProps {
  collectionId: string;
  externalId: string;
  payload: Record<string, unknown>;
}

export const patchCollectionPointsPayload = async ({
  collectionId,
  externalId,
  payload,
}: PatchCollectionPointsPayloadProps): Promise<PatchCollectionPointsPayloadResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<PatchCollectionPointsPayloadResponse>({
    url: `/collections/${orgId}/${collectionId}/points/by-external-id/${encodeURIComponent(externalId)}/payload`,
    method: 'PATCH',
    body: payload,
    target: 'platform',
  });

  if (response?.detail) {
    return { detail: response.detail };
  }

  return response?.data ?? response;
};
